import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const ShoppingBagIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 7.00001V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V7.00001L18.0544 7.00001C18.4785 6.99992 18.8906 6.99984 19.2305 7.04554C19.6137 7.09706 20.051 7.22259 20.4142 7.5858C20.7774 7.94902 20.903 8.38629 20.9545 8.7695C21.0002 9.10941 21.0001 9.52155 21 9.94562L21 15.0706C21 16.4247 21.0001 17.5413 20.8813 18.4251C20.7565 19.3529 20.4845 20.1723 19.8284 20.8284C19.1723 21.4846 18.3529 21.7565 17.4251 21.8813C16.5413 22.0001 15.4247 22.0001 14.0706 22H9.92944C8.57532 22.0001 7.45871 22.0001 6.57495 21.8813C5.64712 21.7565 4.8277 21.4846 4.17159 20.8284C3.51548 20.1723 3.24351 19.3529 3.11877 18.4251C2.99995 17.5413 2.99998 16.4247 3.00001 15.0706L3.00001 9.94561C2.99992 9.52154 2.99984 9.10941 3.04554 8.7695C3.09706 8.38629 3.22259 7.94902 3.5858 7.5858C3.94902 7.22259 4.38629 7.09706 4.76949 7.04554C5.10941 6.99984 5.52154 6.99992 5.94561 7.00001L7.5 7.00001ZM9.5 6.5C9.5 5.11929 10.6193 4 12 4C13.3807 4 14.5 5.11929 14.5 6.5V7.00001H9.5V6.5ZM7.5 9.00001V10C7.5 10.5523 7.94772 11 8.5 11C9.05228 11 9.5 10.5523 9.5 10V9.00001H14.5V10C14.5 10.5523 14.9477 11 15.5 11C16.0523 11 16.5 10.5523 16.5 10V9.00001H18C18.4997 9.00001 18.7738 9.00214 18.964 9.02771L18.9713 9.02871L18.9723 9.03599C18.9979 9.22618 19 9.50034 19 10V15C19 16.4425 18.9979 17.4238 18.8991 18.1586C18.8042 18.8646 18.6368 19.1917 18.4142 19.4142C18.1917 19.6368 17.8646 19.8042 17.1586 19.8991C16.4238 19.9979 15.4425 20 14 20H10C8.55753 20 7.57627 19.9979 6.84145 19.8991C6.13539 19.8042 5.80837 19.6368 5.5858 19.4142C5.36323 19.1917 5.19586 18.8646 5.10093 18.1586C5.00214 17.4238 5.00001 16.4425 5.00001 15V10C5.00001 9.50034 5.00214 9.22618 5.02771 9.03599L5.02871 9.02871L5.03599 9.02771C5.22618 9.00214 5.50034 9.00001 6.00001 9.00001H7.5Z"
          fill={props.color}
        />
      </svg>
    );
  }
);
export default ShoppingBagIcon;
